// Import Vue modules
import Vue from 'vue';
import VueRouter from 'vue-router';
// Path to vuetify export for import
import vuetify from '@/plugins/vuetify'
// Import axios
import axios from 'axios';
// Import BootstrapVue
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// Import prismjs and VuePrismEditor
import 'prismjs';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/themes/prism.css';
import 'vue-prism-editor/dist/VuePrismEditor.css';
// Import Charts from Apex charts
import VueApexCharts from 'vue-apexcharts'
// Import components
import App from './App.vue';
import Home from './components/Dashboard.vue';
import UserIndex from './components/users/Index.vue';
import ProjectConnectionsIndex from './components/connections/Index.vue';
import ProjectConfigIndex from './components/ProjectConfig/Index.vue';
import ProjectIndex from './components/project/Index.vue';
import WebhookIndex from './components/webhooks/Index.vue';
import CronSubscriberIndex from './components/cron_subscribers/Index.vue';
import SubscriberIndex from './components/Subscriber/Index.vue';
import EventIndex from './components/Event/Index.vue';
import SignIn from './components/auth/SignIn.vue';
import SignOut from './components/auth/SignOut.vue';
import AutomaticSignOut from './components/auth/AutomaticSignOut.vue';
import Forbidden from './components/auth/Forbidden.vue';
import LogsIndex from './components/logs/Index.vue';
import TasksIndex from './components/tasks/Index.vue';
import Account from './components/users/Account/Index.vue';
import Info from './components/SyncwareInfo';
import NotFound from './components/NotFound.vue';
import CallLog from "./components/Calls/CallLog";

Vue.config.productionTip = false;

axios.defaults.withCredentials = true;
axios.interceptors.response.use((response) => { // intercept the global error
    return response
}, (error) => {
    if (error.response.status === 401) {
        let currentRoute = router.currentRoute;
        if (currentRoute.path !== '/sign-in' && currentRoute.path !== '/') {
            router.push({
                name: 'automatic_sign-out',
                params: {'currentroute': currentRoute}
            });
        }
    } else if (error.response.status === 403) {
        router.push('/forbidden');
    }

    return Promise.reject(error);
});

// Attach modules
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueApexCharts);

const routes = [
    {path: '/sign-in', name: 'sign-in', component: SignIn},
    {path: '/sign-out', name: 'sign-out', component: SignOut},
    {path: '/automatic_sign-out', name: 'automatic_sign-out', component: AutomaticSignOut},
    {path: '/forbidden', name: 'forbidden', component: Forbidden},

    {path: '/', name: 'home', component: SignIn},
    {path: '/dashboard', name: 'dashboard', component: Home},
    {path: '/cron_subscribers', name: 'cronSubscribers', component: CronSubscriberIndex},
    {path: '/subscribers', name: 'subscribers', component: SubscriberIndex},
    {path: '/events', name: 'events', component: EventIndex},
    {path: '/users', name: 'users', component: UserIndex},
    {path: '/projects/connections/:id', name: 'connection', component: ProjectConnectionsIndex},
    {path: '/projects/config/:id', name: 'projectConfig', component: ProjectConfigIndex},
    {path: '/projects', name: 'projects', component: ProjectIndex},
    {path: '/webhooks', name: 'Webhooks', component: WebhookIndex},
    {path: '/logs', name: 'logs', component: LogsIndex},
    {path: '/tasks', name: 'tasks', component: TasksIndex},
    {path: '/account', name: 'account', component: Account},
    {path: '/calls', name: 'calls', component: CallLog},
    {path: '/info', name: 'info', component: Info},
    {path: '*', name: '404', component: NotFound},
];
Vue.component('apexchart', VueApexCharts);

const router = new VueRouter({routes});

Vue.mixin({
    data: function () {
        return {
            version: "V1.3.0",
            primaryStyle: {
                backgroundColor: '#ff8800',
                color: 'white',
            },
            mainStyle: {
                backgroundColor: '#c0dbe0',
                color: 'black',
            },
            secondaryStyle: {
                backgroundColor: '#748587',
                color: 'white',
            },
            sitionColor: '#ff8800',
            mainColor: '#c0dbe0',
            secondaryColor: '#748587'
        }
    }
});

new Vue({
    router,
    vuetify,
    render: h => h(App),
}).$mount('#app');
